import { render } from "./ExamEditView.vue?vue&type=template&id=bc991562&scoped=true"
import script from "./ExamEditView.vue?vue&type=script&lang=js"
export * from "./ExamEditView.vue?vue&type=script&lang=js"

import "./ExamEditView.vue?vue&type=style&index=0&id=bc991562&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bc991562"]])

export default __exports__